import React, { useState } from 'react';
import Intro from './components/Intro/Intro';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import Rooms from './components/Rooms/Rooms';
import Amenities from './components/Amenities/Amenities';
import Gallery from './components/Gallery/Gallery';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import './App.css';

function App() {
  const [showIntro, setShowIntro] = useState(true);

  const handleIntroComplete = () => {
    setShowIntro(false);
  };

  return (
    <div className="App">
      {showIntro && <Intro onComplete={handleIntroComplete} />}
      {!showIntro && (
        <>
          <Header />
          <Hero />
          <About />
          <Rooms />
          <Amenities />
          <Gallery />
          <Contact />
          <Footer />
        </>
      )}
    </div>
  );
}

export default App;

